import { createContext, useContext } from 'react';

/** Screen Y coordinate of the bottom edge of the fixed mobile-web chat container. */
export const MobileWebChatContainerBottomContext = createContext<number | null>(
    null,
);

export const useMobileWebChatContainerBottom = (): number | null => {
    return useContext(MobileWebChatContainerBottomContext);
};
